<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Headline</label>
      <input v-model="localSection.content.headline" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Subheadline</label>
      <textarea v-model="localSection.content.subheadline" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate" />
    </div>

    <div class="grid grid-cols-1 gap-3">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Primary CTA Text</label>
        <input v-model="localSection.content.ctaText" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Primary CTA Link</label>
        <input v-model="localSection.content.ctaLink" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Secondary CTA Text</label>
        <input v-model="localSection.content.secondaryCtaText" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Secondary CTA Link</label>
        <input v-model="localSection.content.secondaryCtaLink" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Background Image URL</label>
      <input v-model="localSection.content.backgroundImage" type="text" placeholder="https://..." class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Headline Color</label>
        <input v-model="localSection.styles.headlineColor" type="color" class="w-full h-10 border border-gray-300 rounded cursor-pointer" @input="emitUpdate">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Subheadline Color</label>
        <input v-model="localSection.styles.subheadlineColor" type="color" class="w-full h-10 border border-gray-300 rounded cursor-pointer" @input="emitUpdate">
      </div>
    </div>

    <section-style-fields :section="localSection" @update="applyStyles" />
  </div>
</template>

<script>
import SectionStyleFields from './SectionStyleFields.vue'

export default {
  components: { SectionStyleFields },
  props: { section: { type: Object, required: true } },
  emits: ['update'],
  data() {
    return { localSection: JSON.parse(JSON.stringify(this.section)) }
  },
  watch: {
    section: {
      handler(value) { this.localSection = JSON.parse(JSON.stringify(value)) },
      deep: true,
    },
  },
  methods: {
    emitUpdate() { this.$emit('update', JSON.parse(JSON.stringify(this.localSection))) },
    applyStyles(section) { this.localSection = section; this.emitUpdate() },
  },
}
</script>
